module.exports = __webpack_public_path__ + "static/media/IMG_3073.f3c69f19.JPG";